export const updateSelectedTab = (selectedTabIndex) => {
    return (dispatch, getState) => {
        dispatch({ type: 'SELECTED_TAB_UPDATE', selectedTabIndex })
    }
}
